import React, { useState } from 'react';
import { string, bool } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import fileIcon from '../../../../assets/architect-design.png';
import { Form, IconClose } from '../../../../components';

import {
  FormattedMessage,
  injectIntl,
  intlShape,
} from '../../../../util/reactIntl';
// import { uploadToAws } from '../../../../util/types';

import css from './AttachmentModal.module.css';
import Button from '../../../Button/Button';
import { FieldAddImage } from '../../../../containers/EditListingPage/EditListingWizard/EditListingPhotosPanel/EditListingPhotosForm';
import {
  deleteAwsFileApi,
  deleteImageFromCloudinary,
  generatePresignedUrl,
} from '../../../../util/api';
import IconCollection from '../../../IconCollection/IconCollection';
import Loader from '../../../Loader/Loader';
import { getFileExtension } from '../../../../util/dataExtractor';
import { uploadWithPresignedUrl } from '../../../../util/awsUpload';

const ACCEPT_IMAGES = 'image/*,application/pdf';
const ACCEPT_otherfiles = '.rvt,.dwg,.nwd,.ifc,.nwc,.docx,.doc';

const AttachmentModalComponent = props => {
  const { state } = props;

  return (
    <FinalForm
      {...props}
      mutators={{ ...arrayMutators }}
      keepDirtyOnReinitialize={true}
      render={formRenderProps => {
        const {
          form,
          // className,
          // fetchErrors,
          handleSubmit,
          // intl,
          // invalid,
          // values,
          cloudUrls,
          fileUrls,
          setFileUrls,
          setCloudUrls,
          prevValues,
          addToForm,
          awsFile,
          setAwsFile,
          cloudImage,
          setCloudImage,
        } = formRenderProps;

        const [error, setError] = useState({ message: false, status: false });

        const onImageUploadHandlerportflio = file => {
          if (!file) {
            setError({ status: false, message: false });
            return;
          }
          const maxSizeMB = 10;
          const allowedExtensions = [
            'image/jpeg',
            'image/png',
            'application/pdf',
          ];
          // Check file size
          if (file.size > maxSizeMB * 1024 * 1024) {
            setError({
              status: true,
              message: `File size exceeds ${maxSizeMB} MB.`,
            });
            return;
          }
          // Check file type
          if (!allowedExtensions.includes(file.type)) {
            setError({
              status: true,
              message:
                'Invalid file type. Only JPEG, PNG, and PDF files are allowed.',
            });
            return;
          }
          setError({ message: false, status: false });
          setCloudImage({ ...cloudImage, cloudImageInProgress: true });
          const uploadURL = process.env.REACT_APP_CLOUDINARY_URL;
          const formData = new FormData();
          const fileType = file.type;
          formData.append('file', file);
          formData.append(
            'upload_preset',
            process.env.REACT_APP_CLOUDINARY_PRESET
          );
          formData.append('resource_type', fileType);
          formData.append('api_key', process.env.REACT_APP_CLOUDINARY_API_KEY);
          formData.append('folder', 'attachmentCloudinary');
          fetch(uploadURL, { method: 'POST', body: formData })
            .then(response => response.text())
            .then(data => {
              const res = JSON.parse(data);
              // let existingImageUrls = prevValues?.attachmentCloudinary || [];
              // existingImageUrls.push({ secure_url: res.secure_url, public_id: res.public_id, resource_type: res.resource_type });
              setCloudUrls(prev => [
                ...prev,
                {
                  secure_url: res.secure_url,
                  public_id: res.public_id,
                  resource_type: res.resource_type,
                },
              ]);
              setCloudImage({ ...cloudImage, cloudImageInProgress: false });
            })
            .catch(err =>
              setCloudImage({ ...cloudImage, cloudImageInProgress: false })
            );
        };

        const handleDeleteImage = (index, url) => {
          setCloudImage({ ...cloudImage, cloudImageRemoveInProgress: true });
          const { public_id, resource_type } = url;
          deleteImageFromCloudinary({ public_id, resource_type })
            .then(res => {
              let existingImageUrls = prevValues?.attachmentCloudinary || [];
              existingImageUrls.splice(index, 1);
              setCloudUrls(existingImageUrls);
              setCloudImage({
                ...cloudImage,
                cloudImageRemoveInProgress: false,
              });
            })
            .catch(err => {
              console.error('Error deleting image from Cloudinary:', err);
              setCloudImage({
                ...cloudImage,
                cloudImageRemoveInProgress: false,
              });
            });
        };

        const handleAwsFiles = async file => {
          const MAX_FILE_SIZE_MB = 1500; // Maximum file size in megabytes (1.5 GB)
          if (!file) {
            setError({ message: false, status: false });
            return;
          }

          const fileExtension = `.${getFileExtension(file.name)}`;
          // Check file size
          if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
            setError({
              status: true,
              message: `File size exceeds ${MAX_FILE_SIZE_MB} MB.`,
            });
            return;
          }

          // Check file type
          if (!ACCEPT_otherfiles.includes(fileExtension)) {
            setError({
              status: true,
              message:
                'Invalid file type. Only the following file types are allowed: .rvt, .dwg, .nwd, .ifc, .nwc, .docx, .doc.',
            });
            return;
          }

          // Clear error if everything is okay
          setError({ status: false, message: false });

          if (file) {
            setAwsFile({ ...awsFile, awsFileInProgress: true });
            const payload = {
              fileName: file.name,
              fileType: getFileExtension(file.name),
            };
            const { url, key } = await generatePresignedUrl(payload);
            const uploadPayload = {
              url,
              file,
              fileType: getFileExtension(file.name),
              setAwsFile,
              awsFile,
              key,
            };
            const uploadResponse = await uploadWithPresignedUrl(uploadPayload);
            if (uploadResponse)
              setFileUrls(prevFileUrls => {
                if (Array.isArray(prevFileUrls)) {
                  return [...prevFileUrls, uploadResponse];
                } else {
                  return [uploadResponse];
                }
              });
          }
        };
        const removeAwsFiles = async key => {
          setAwsFile({ ...awsFile, awsFileRemoveInProgress: true });
          try {
            const res = await deleteAwsFileApi({ key: key });
            const updateFile = fileUrls?.filter(elm => elm.key !== key);
            setFileUrls(updateFile);
            setAwsFile({ ...awsFile, awsFileRemoveInProgress: false });
          } catch (error) {
            console.log('error-->>>', error);
            setAwsFile({ ...awsFile, awsFileRemoveInProgress: false });
          }
        };
        const handleDrop = async event => {
          const file = event.dataTransfer.files[0];
          if (!!file) {
            try {
              await onImageUploadHandlerportflio(file);
            } catch (error) {
              console.log('error', error);
            }
          } else {
            alert('File uploading failed!');
          }
        };

        const handleDropAWS = async event => {
          const file = event.dataTransfer.files[0];
          if (!!file) {
            await handleAwsFiles(file);
          } else {
            alert('File uploading failed!');
          }
        };
        const onSubmit = e => {
          e.preventDefault();
          e.stopPropagation();
          addToForm.change('attachmentCloudinary', cloudUrls);
          addToForm.change('attachmentAwsFiles', fileUrls);
          handleSubmit();
        };

        return (
          <Form className={css.formWrapper} onSubmit={onSubmit}>
            <h3>Add Attachments</h3>
            <label>Add Image and PDF files</label>
            <div className={css.portfolioImage}>
              {cloudImage?.cloudImageInProgress ? (
                <div className={css.loaderWrapper}>
                  <div className={css.loaderBox}>
                    <Loader />
                  </div>
                </div>
              ) : (
                <div
                  className={css.pdfDocGrid}
                  onDrop={event => handleDrop(event)}
                  onDragOver={event => event.preventDefault()}
                >
                  <FieldAddImage
                    id="addImage"
                    name="addImage"
                    accept={ACCEPT_IMAGES}
                    labelOne={
                      <FormattedMessage id="EditListingPhotosForm.chooseFile" />
                    }
                    labelTwo={
                      <FormattedMessage id="EditListingPhotosForm.imageTypes" />
                    }
                    type="file"
                    disabled={state.imageUploadRequested}
                    formApi={form}
                    onImageUploadHandler={onImageUploadHandlerportflio}
                    aspectWidth={1}
                    aspectHeight={1}
                  />
                </div>
              )}
              {cloudUrls?.map((url, index) => (
                <div key={index} className={css.imageBox}>
                  {cloudImage?.cloudImageRemoveInProgress ? (
                    <div className={css.loaderWrapper}>
                      <div className={css.loaderBox}>
                        <Loader />
                      </div>
                    </div>
                  ) : (
                    <>
                      <embed
                        className={css.img}
                        src={url.secure_url}
                        alt={'img'}
                      />
                      <button
                        className={css.deleteImage}
                        type="button"
                        onClick={() => handleDeleteImage(index, url)}
                      >
                        <IconClose />
                      </button>
                    </>
                  )}
                </div>
              ))}
            </div>

            {/* <p className={css.tip}>
              <FormattedMessage id="EditListingPhotosForm.addImagesTip" />
            </p> */}
            {error?.status ? (
              <p className={css.error}>
                <FormattedMessage id={error.message} />
              </p>
            ) : null}
            <label>Add BIM and CAD files</label>
            <div className={css.portfolioImage}>
              {awsFile?.awsFileInProgress ? (
                <div className={css.loaderWrapper}>
                  <div className={css.loaderBox}>
                    <div className={css.progressContainer}>
                      <progress
                        value={awsFile?.fileProgressPercentage}
                        max={100}
                      ></progress>
                      <div className={css.progressLabel}>
                        {awsFile?.fileProgressPercentage}% Complete
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={css.pdfDocGrid}
                  onDrop={event => handleDropAWS(event)}
                  onDragOver={event => event.preventDefault()}
                >
                  <FieldAddImage
                    id="addFile"
                    name="addFile"
                    accept={ACCEPT_otherfiles}
                    labelOne={
                      <FormattedMessage id="EditListingPhotosForm.chooseFile" />
                    }
                    labelTwo={
                      <FormattedMessage id="EditListingPhotosForm.fileTypes" />
                    }
                    type="file"
                    disabled={state.imageUploadRequested}
                    formApi={form}
                    onImageUploadHandler={handleAwsFiles}
                    aspectWidth={1}
                    aspectHeight={1}
                  />
                </div>
              )}
              {fileUrls &&
                fileUrls.length > 0 &&
                fileUrls.map((file, index) => {
                  const fileName = file.key.split('-').pop();
                  return (
                    <div className={css.documentWrapper} key={index}>
                      {awsFile?.awsFileRemoveInProgress ? (
                        <div className={css.loaderWrapper}>
                          <div className={css.loaderBox}>
                            <Loader />
                          </div>
                        </div>
                      ) : (
                        <div className={css.documentContent}>
                          <img
                            src={fileIcon}
                            alt="fileIcon"
                            width={50}
                            height={50}
                          />
                          <div>
                            <div className={css.fileText} title={fileName}>
                              <b>FileName: </b>
                              {fileName && fileName.length > 15
                                ? fileName.substring(0, 15) + '...'
                                : fileName}
                            </div>
                            <button
                              className={css.removeImage}
                              type="button"
                              onClick={() => {
                                removeAwsFiles(file?.key);
                              }}
                            >
                              <IconCollection name="CLOSE_ICON" />
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>

            <p className={css.tip}>
              <FormattedMessage id="EditListingPhotosForm.awsFileTip" />
            </p>
            <p className={css.tip}>
              <FormattedMessage id="EditListingPhotosForm.awsFileTip2" />
            </p>

            <Button
              type="submit"
              disabled={
                error?.status ||
                awsFile?.awsFileInProgress ||
                cloudImage?.cloudImageInProgress
              }
            >
              <FormattedMessage id="AttachmentModal.saveButton" />
            </Button>
          </Form>
        );
      }}
    />
  );
};

AttachmentModalComponent.defaultProps = {
  rootClassName: null,
  className: null,
};

AttachmentModalComponent.propTypes = {
  rootClassName: string,
  className: string,

  inProgress: bool,

  // from injectIntl
  intl: intlShape.isRequired,
};

const AttachmentModal = compose(injectIntl)(AttachmentModalComponent);

AttachmentModal.displayName = 'AttachmentModal';

export default AttachmentModal;
